module.exports = __webpack_public_path__ + "img/play-icon.c8fd49c7.svg";